import React from "react";
import { Paperclip } from "lucide-react";
import { SUB_STATUS } from "@/lib/exercises";

export function FileLinks({ files = [], urlFor, testPrefix }) {
  if (!files.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {files.map((f) => (
        <a key={f.id} href={urlFor(f.id)} target="_blank" rel="noreferrer" data-testid={`${testPrefix}-${f.id}`}
          className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-stone-50 border border-stone-200 text-[11px] hover:border-[#1C352D] transition-colors">
          <Paperclip size={11}/> {f.filename}
        </a>
      ))}
    </div>
  );
}

export function SubStatusBadge({ status, late }) {
  const s = SUB_STATUS[status] || SUB_STATUS.consegnato;
  return (
    <span className="inline-flex gap-1">
      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border ${s.cls}`} data-testid={`sub-status-${status}`}>{s.label}</span>
      {late && <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full border bg-red-50 text-red-700 border-red-200" data-testid="sub-late">In ritardo</span>}
    </span>
  );
}
